import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
    signal
} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-modal-notification',
    templateUrl: './modal-notification.component.html',
    styleUrls: ['./modal-notification.component.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'block' }
})
export class ModalNotificationComponent implements OnInit {
    readonly message = signal('');
    readonly color = signal<'success' | 'info' | 'warning' | 'error'>('info');
    readonly multiline = signal<string[]>([]);
    readonly iconClass = signal<string | null>(null);

    private _autoCloseTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        private readonly _data: {
            message: string;
            color: 'success' | 'info' | 'warning' | 'error';
            duration: number;
            multiline?: string[] | null;
            iconClass?: string | null;
        },
        private readonly _matDialogRef: MatDialogRef<ModalNotificationComponent>
    ) {
        if (this._data?.message) {
            this.message.set(this._data.message);
        }
        if (this._data?.color) {
            this.color.set(this._data.color);
        }
        if (this._data?.multiline?.length) {
            this.multiline.set(this._data.multiline);
        }
        this.iconClass.set(this._data?.iconClass ?? null);
    }

    ngOnInit(): void {
        const duration = Number(this._data?.duration);
        if (Number.isFinite(duration) && duration > 0) {
            this._autoCloseTimer = setTimeout(() => this.close(true), duration);
        }
    }

    titleForColor(): string {
        switch (this.color()) {
            case 'success':
                return '¡Operación exitosa!';
            case 'info':
                return '¡Importante!';
            case 'warning':
                return '¡Advertencia!';
            case 'error':
                return '¡Lo sentimos!';
            default:
                return 'Notificación';
        }
    }

    close(_data?: boolean): void {
        if (this._autoCloseTimer) {
            clearTimeout(this._autoCloseTimer);
            this._autoCloseTimer = null;
        }
        this._matDialogRef.close(true);
    }
}
